"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_ATTRIBUTIONS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_CATALOG_ATTRIBUTIONS = (0, gql_1.gql)(`
  query AggregatedTextAttributesAsColumns(
    $catalogId: ID!,
    $filter: CatalogAttributionFilter,
    $first: Int,
    $after: ID,
    $before: ID,
    $last: Int,
  ) {
    catalogs(ids: [$catalogId]) {
      edges {
        node {
          id
          attributions(filter: $filter, first: $first, after: $after, before: $before, last: $last) {
            edges {
              node {
                attribute
                type
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
          }
        }
      }
    }
  }
`);
